import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  Inject,
  input,
  signal,
  effect,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthLoginState } from '../../core/auth/auth.models';
import { FaIconComponent, IconDefinition } from '@fortawesome/angular-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faTiktok, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'dottnet-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [FaIconComponent, TranslatePipe, RouterLink],
})
export class FooterComponent implements OnInit, OnDestroy {
  // Input signals
  readonly authLoginState = input<AuthLoginState | null>(null);
  readonly facebookLink = input<string>('');
  readonly twitterLink = input<string>('');
  readonly linkedinLink = input<string>('');
  readonly instagramLink = input<string>('');

  // Icons
  facebook: IconDefinition = faFacebook;
  x: IconDefinition = faXTwitter;
  linkedin: IconDefinition = faLinkedin;
  instagram: IconDefinition = faInstagram;
  tiktok: IconDefinition = faTiktok;

  // Internal signals
  isUserLogged = signal<boolean>(false);

  // Subs (non necessario con i signal, ma lo mantengo per compatibilità temporanea)
  private userLoggedSub?: Subscription;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    // Effect per reagire ai cambiamenti dell'authLoginState
    effect(() => {
      this.updateUserLoggedStatus(this.authLoginState());
    });

    // Effect per reagire ai cambiamenti di isUserLogged
    effect(() => {
      const isLogged = this.isUserLogged();
    });
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Inizializza il valore dello stato dell'autenticazione
      this.updateUserLoggedStatus(this.authLoginState());
    }
  }

  // Questo metodo può essere utilizzato come effect per reagire ai cambiamenti dell'authLoginState
  private updateUserLoggedStatus(authLoginState: AuthLoginState | null): void {
    if (authLoginState) {
      this.isUserLogged.set(
        [AuthLoginState.LOGGEDHARD, AuthLoginState.LOGGEDSOFT].includes(authLoginState)
      );
    } else {
      this.isUserLogged.set(false);
    }
  }

  ngOnDestroy(): void {
    if (this.userLoggedSub) this.userLoggedSub.unsubscribe();
  }
}
